export default {
  firstName: {
    id: 'bo_seller.kyb.stakeholder.first_name',
    defaultMessage: 'First name',
  },
  lastName: {
    id: 'bo_seller.kyb.stakeholder.last_name',
    defaultMessage: 'Last name',
  },
  dateOfBirth: {
    id: 'bo_seller.kyb.stakeholder.date_of_birth',
    defaultMessage: 'Date of birth',
  },
  countryOfCitizenship: {
    id: 'bo_seller.kyb.stakeholder.country_of_citizenship',
    defaultMessage: 'Country of citizenship',
  },
  phoneNumber: {
    id: 'bo_seller.kyb.stakeholder.phone_number',
    defaultMessage: 'Phone number',
  },
  countryOfResidency: {
    id: 'bo_seller.kyb.stakeholder.country_of_residency',
    defaultMessage: 'Country of residency',
  },
  address: {
    id: 'bo_seller.kyb.stakeholder.address',
    defaultMessage: 'Address',
  },
  governmentIssuedIdentification: {
    id: 'bo_seller.kyb.stakeholder.government_issued_identification',
    defaultMessage: 'Government issued identification',
  },
} as const
